import TableOnly from "components/DataTable/TableOnly";
import Pagination from "components/Pagination/Pagination";
import SearchComp from "components/SearchComp/SearchComp";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import DeleteModalButton from "../../../../components/DeleteModalBtn/DeleteModalButton";
import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import SProductsAddUpdate from "./SProductsAddUpdate";

let API_URL = "/sales/products";
let COMPONENT_URL = "/sales/products";
let COMPONENT_DETAILS_URL = "/sales/products";

let limits = [5, 10, 15, 20];

export default function SProducts() {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  /*   ALL STATES
   ********************************************* */
  const [productsData, setProductsData] = useState([]);

  const [totalPages, setTotalPages] = useState(
    parseInt(searchParams.get("totalPages")) || 1,
  );

  if (searchParams.get("limit") === null) {
    setSearchParams((prev) => {
      let limit = searchParams.get("limit") || "10";
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", limit);
      return newParams.toString();
    });
  }
  if (searchParams.get("page") === null) {
    setSearchParams((prev) => {
      let page = searchParams.get("page") || "1";
      const newParams = new URLSearchParams(prev);
      newParams.set("page", page);
      return newParams.toString();
    });
  }

  const [showAddModal, setShowAddModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [isUpdateMode, setIsUpdateMode] = useState(false);

  const [filterBy, setFilterBy] = useState("all");
  const [productTypesList, setProductTypesList] = useState([]);
  const [selectedProductTypeId, setSelectedProductTypeId] = useState(null);

  const [loading, setLoading] = useState(false);

  /*   All Functions
   ********************************************* */
  const changeLimit = (val) => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set("limit", val);
      return newParams.toString();
    });
  };

  const getSearchParamsWithoutGivenKey = (key) => {
    let params = new URLSearchParams(searchParams);
    params.delete(key);
    return params.toString();
  };

  //get Data
  const getProductsData = async () => {
    try {
      setLoading(true);

      let page = parseInt(searchParams.get("page")) || 1;
      let limit = parseInt(searchParams.get("limit")) || 10;
      let query = searchParams.get("query") || "";

      let body = { page, limit, filterBy };

      if (query) {
        body.query = query;
      }

      if (selectedProductTypeId) {
        body.productTypeId = selectedProductTypeId;
      }

      const { data } = await API.post(API_URL, body, {
        headers: authHeader(),
      });
      if (data.success) {
        setProductsData(data.data);
        setTotalPages(data.totalPages);
        return data.data;
      } else {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  // Delete
  const deleteProductsData = async (id) => {
    try {
      setLoading(true);
      const { data } = await API.delete("/sales/product/" + id, {
        headers: authHeader(),
      });
      if (data?.success) {
        // setProductsData((prev) => prev.filter((item) => item.id !== id));
        await getProductsData();
        dispatch(
          setNotification({
            message: data?.message,
            type: "success",
          }),
        );
        return;
      }
      dispatch(
        setNotification({
          message: data?.message,
          type: "error",
        }),
      );
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateData = async (item) => {
    setFormData(item);
    setIsUpdateMode(true);
    setShowAddModal(true);
  };

  // Sorting Up
  const sortUp = async (id) => {
    const index = productsData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === 0) return;
    if (index === productsData.length) return;

    const currentSortId = productsData[index]?.sortId;
    const currentId = productsData[index]?.id;
    const upSortId = productsData[index - 1].sortId;
    const upId = productsData[index - 1].id;
    try {
      const { data } = await API.post(
        "sales/product/sortup",
        { currentSortId, currentId, upSortId, upId },
        { headers: authHeader() },
      );
      if (data.success) {
        await getProductsData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  // Sorting Up
  const sortDown = async (id) => {
    const index = productsData.findIndex((item) => item.id === id);
    if (index === -1) return;
    if (index === productsData.length - 1) return;

    const currentSortId = productsData[index]?.sortId;
    const currentId = productsData[index]?.id;
    const downSortId = productsData[index + 1].sortId;
    const downId = productsData[index + 1].id;

    try {
      const { data } = await API.post(
        "sales/product/sortDown",
        { currentSortId, currentId, downSortId, downId },
        { headers: authHeader() },
      );
      if (data.success) {
        await getProductsData();
      }
    } catch (err) {
      alert(err.message);
    }
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      getProductsData();
    }, 50);
    return () => clearTimeout(timeout);
  }, [searchParams, filterBy, selectedProductTypeId]);

  // Fetch product types on mount
  useEffect(() => {
    const fetchProductTypes = async () => {
      try {
        const { data } = await API.get("/productTypes", {
          headers: authHeader(),
        });
        data.sort((a, b) => a.sortId - b.sortId);
        setProductTypesList(data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProductTypes();
  }, []);

  /*   Table functions
   ********************************************* */
  const btn1 = () => (
    <div>
      <>
        <button
          onClick={() => {
            setShowAddModal(true);
            setFormData({});
            setIsUpdateMode(false);
          }}
          type="button"
          className="btn btn-primary"
        >
          Add Product
        </button>
      </>
    </div>
  );

  let filters = [
    { name: "All", value: "all" },
    { name: "By Style ID", value: "styleId" },
    { name: "Desc", value: "desc" },
    { name: "Fabric", value: "fabric" },
  ];

  const RenderFilters = () => {
    return (
      <Dropdown>
        <Dropdown.Toggle variant="outline-primary" id="dropdown-basic">
          {filters.find((f) => f.value === filterBy)?.name || "Filter By"}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {filters.map((filter) => (
            <Dropdown.Item
              key={filter.value}
              onClick={() => {
                setFilterBy(filter.value);
                setSearchParams((prev) => {
                  const newParams = new URLSearchParams(prev);
                  newParams.set("filterBy", filter.value);
                  return newParams.toString();
                });
              }}
            >
              {filter.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const table_head = [
    { name: "ID", value: "productId" },
    { name: "Product Type", value: "productType.productTypes" },
    { name: "Style ID", value: "styleId" },
    { name: "Description", value: "desc" },
    { name: "Fabric", value: "item?.s_fabric?.name" },
    { name: "Actions", value: "Actions" },
  ];

  const table_body = (item, index) => (
    <tr className="" key={item.id}>
      <td className="py-0 align-middle">{item.productId}</td>
      <td className="py-0 align-middle">{item?.productType?.productTypes}</td>
      <td className="py-0 align-middle">{item.styleId}</td>
      <td className="py-0 align-middle">{item.desc}</td>

      <td className="py-0 align-middle">{item?.s_fabric?.name}</td>

      <td className="py-0 align-middle table-action">
        <button
          onClick={() => {
            item.sort_id !== 1 && sortUp(item?.id);
          }}
          disabled={item.sort_id === 1}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-up"></i>
        </button>
        <button
          onClick={() => {
            item.sort_id !== productsData.length && sortDown(item?.id);
          }}
          disabled={item.sort_id === productsData.length}
          className="action-icon border-0 btn"
        >
          <i className="mdi mdi-chevron-double-down"></i>
        </button>
        <button
          disabled={loading}
          onClick={() => {
            handleUpdateData(item);
          }}
          className="btn px-1"
        >
          <i className="mdi mdi-pencil"></i>
        </button>

        <DeleteModalButton
          btnClass={"btn  px-1"}
          deleteFunc={deleteProductsData}
          deleteParams={item.id}
          disableConditions={loading}
        />
      </td>
    </tr>
  );

  return (
    <div className="p-2" style={{ height: "90vh" }}>
      {loading && <Spinner />}

      {/*   Table
       ********************************************* */}
      <div className="px-2" style={{ minHeight: "60vh", borderRadius: 15 }}>
        <div className="">
          <div className="">
            <div className="d-flex justify-content-end align-items-center gap-1 mb-3">
              <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center gap-1">
                  <div>Show</div>
                  <button
                    className="px-1 bg-primary bg-opacity-10 border border-primary rounded-end rounded-start "
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {searchParams.get("limit")}
                  </button>
                  <ul
                    style={{ width: "fit-content" }}
                    className="dropdown-menu"
                  >
                    {limits.map((limit) => (
                      <li key={limit}>
                        <button
                          className="dropdown-item"
                          onClick={() => changeLimit(limit)}
                        >
                          {limit}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="d-flex align-items-center gap-2 me-2">
                <h5>Filter By Type</h5>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-primary"
                    id="productType-dropdown"
                  >
                    {selectedProductTypeId
                      ? productTypesList.find(
                          (pt) => pt.productTypeId === selectedProductTypeId,
                        )?.productTypes || "Product Type"
                      : "All Types"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => setSelectedProductTypeId(null)}
                    >
                      All Types
                    </Dropdown.Item>
                    {productTypesList.map((pt) => (
                      <Dropdown.Item
                        key={pt.id}
                        onClick={() =>
                          setSelectedProductTypeId(pt.productTypeId)
                        }
                      >
                        {pt.productTypes}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="d-flex align-items-center gap-2">
                <h5>Search By</h5>
                {RenderFilters()}
              </div>

              <SearchComp
                setLoading={setLoading}
                clearFunc={() => {
                  setFilterBy("all");
                }}
                apiPath={`${COMPONENT_URL}${
                  getSearchParamsWithoutGivenKey("query")
                    ? "?" + getSearchParamsWithoutGivenKey("query") + "&"
                    : "?"
                }`}
              />
              <div className="">{btn1()}</div>
            </div>

            <div
              className="mb-3"
              style={{ height: "75vh", overflowY: "auto", borderRadius: 15 }}
            >
              <TableOnly
                table_head={table_head}
                table_body={table_body}
                table_data={productsData || []}
                totalPages={totalPages}
                disableSorting={true}
              />
            </div>
            {loading && <Spinner />}
            {!searchParams.get("query") && (
              <Pagination
                totalPages={totalPages}
                apiPath={`${COMPONENT_URL}${
                  searchParams.toString()
                    ? "?" + getSearchParamsWithoutGivenKey("page") + "&"
                    : "?"
                }page=`}
                currPage={parseInt(searchParams.get("page")) || 1}
              />
            )}
          </div>
        </div>
      </div>
      {/*   ADD Modal
       ********************************************* */}
      <Modal
        size="xl"
        show={showAddModal}
        onHide={() => setShowAddModal(false)}
      >
        <Modal.Body
          className="shadow-lg bg-light px-3 "
          style={{ borderRadius: 15 }}
        >
          <SProductsAddUpdate
            setShowAddModal={setShowAddModal}
            formData={formData}
            setFormData={setFormData}
            isUpdateMode={isUpdateMode}
            setProductsData={setProductsData}
            setIsUpdateMode={setIsUpdateMode}
            refreshFunc={getProductsData}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
}
